
import { Vue, Component, Prop } from "vue-property-decorator";

import TableRow from "@/components/table/table-row.vue";
import TableAvatar from "@/components/table/TableAvatar.vue";
import TableBadge from "@/components/table/table-badge.vue";

import { User, Company } from "@/generated/graphql";
import RouteNames from "@/entities/RouteNames";
import Roles from "@/entities/Roles";
import ColorIconContainer from "@/components/icons/ColorIconContainer.vue";
import ChatIcon from "@/components/icons/ChatIcon.vue";

@Component({
  components: {
    TableAvatar,
    TableBadge,
    TableRow,
    ColorIconContainer,
    ChatIcon,
  },
})
export default class ConnectionTableItem extends Vue {
  @Prop({ type: Object, required: true }) readonly user!: User;
  @Prop({ type: Number, default: 0 }) readonly cols!: number;
  @Prop({ type: Array, default: () => [] }) readonly columns!: string[];

  routeNames = RouteNames;

  get userCompany(): Company | undefined {
    if (this.user.admin) {
      return this.user.admin.company;
    }
    if (this.user.manager) {
      return this.user.manager.company;
    }
  }

  get roleColor(): string {
    if (this.user.role === Roles.ADMIN) {
      return "pink";
    }
    
    return "indigo";
  }

  message(): void {
    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: this.user.id,
      },
    });
  }
}
